var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRemoteWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.01,
    height: 21.01,
    viewBox: "0 0 11.01 21.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.26,5H1.74c-.96,0-1.73.78-1.74,1.74v12.53c0,.96.78,1.73,1.74,1.74h7.53c.96,0,1.73-.78,1.74-1.74V6.74c0-.96-.78-1.73-1.74-1.74h-.01ZM10,19.26c0,.41-.33.74-.74.74H1.74c-.41,0-.74-.33-.74-.74V6.74c0-.41.33-.74.74-.74h7.53c.41,0,.74.33.74.74v12.53h-.01Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2.85,2.03c1.39-1.32,3.57-1.32,4.96,0,.21.18.52.16.71-.05.17-.19.17-.48,0-.67C6.75-.44,3.91-.44,2.15,1.31c-.21.18-.23.5-.05.71s.5.23.71.05l.04-.04h0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3.56,2.74c-.19.2-.19.51,0,.71.2.19.51.19.71,0,.59-.56,1.51-.56,2.1,0,.19.2.51.2.71,0s.2-.51,0-.71h0c-.98-.95-2.55-.95-3.53,0h0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.5,13c-1.38,0-2.5,1.12-2.5,2.5s1.12,2.5,2.5,2.5,2.5-1.12,2.5-2.5-1.12-2.5-2.5-2.5ZM5.5,17c-.83,0-1.5-.67-1.5-1.5s.67-1.5,1.5-1.5,1.5.67,1.5,1.5-.67,1.5-1.5,1.5Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3.5,9h1c.28,0,.5-.22.5-.5s-.22-.5-.5-.5h-1c-.28,0-.5.22-.5.5s.22.5.5.5Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3.5,11h1c.28,0,.5-.22.5-.5s-.22-.5-.5-.5h-1c-.28,0-.5.22-.5.5s.22.5.5.5Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.5,8h-1c-.28,0-.5.22-.5.5s.22.5.5.5h1c.28,0,.5-.22.5-.5s-.22-.5-.5-.5Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.5,10h-1c-.28,0-.5.22-.5.5s.22.5.5.5h1c.28,0,.5-.22.5-.5s-.22-.5-.5-.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoteWhite);
export default __webpack_public_path__ + "static/media/remoteWhite.51af7e45.svg";
export { ForwardRef as ReactComponent };